export class Telephone {
	id?: number;
	code: string;
	number: string;
}
